import React from "react";
import { Card, CardMedia, CardContent, Typography, CardActionArea, Grid } from "@mui/material";
import { useStyles } from "./card-with-title-style";
import contentBg from "assets/images/course.png";
import ArrowForwardSharpIcon from "@mui/icons-material/EastSharp";
import { ELEMENT_ID } from "utils/constants";

type CardProps = {
  id: string;
  item?: any;
  onCardClick?: (event: any) => void;
};

export const CardWithTitle: React.FC<CardProps> = ({ id, item, onCardClick }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea onClick={onCardClick} role="link" aria-label={item.name} id={id}>
        <CardMedia
          className={classes.media}
          image={
            process.env.REACT_APP_SHOW_DEFAULT_IMAGE_IBF.toString() === "true"
              ? contentBg
              : `${item.imageUrl}`
          }
          id={`${id}-${ELEMENT_ID.IMAGE}`}
          title={`${item.name}`}
        />
        <CardContent className={classes.content}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 9 }}>
              <Typography id={`${id}-${ELEMENT_ID.NAME}`} className={classes.contentHeader}>
                {item.name}
              </Typography>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <ArrowForwardSharpIcon />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
